import { render, staticRenderFns } from "./EditPrice.vue?vue&type=template&id=6b1c7e6e&scoped=true"
import script from "./EditPrice.vue?vue&type=script&lang=js"
export * from "./EditPrice.vue?vue&type=script&lang=js"
import style0 from "./EditPrice.vue?vue&type=style&index=0&id=6b1c7e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1c7e6e",
  null
  
)

export default component.exports